import Skeleton from 'react-loading-skeleton';

import { useDeleteUser, useGetUser } from '@/api';
import { Button } from '@/components/shared/Button';
import { useModalStore } from '@/store';
import { formatNumberToStr } from '@/utils';

import cn from './styles.module.sass';

export const DeleteProfileContent = () => {
    const { data: userData } = useGetUser();
    const { mutate: deleteUser } = useDeleteUser();

    const { setIsProfileDeletionOpen } = useModalStore();

    const handleDeleteUser = () => {
        deleteUser();
        setIsProfileDeletionOpen(false);
    };

    return (
        <div className={cn.container}>
            <h2 className={cn.heading}>Удаление профиля</h2>
            <p className={cn.description}>
                Ты уверен, что хочешь безвозвратно удалить профиль, привязанный к номеру
            </p>
            <p className={cn.phone}>
                {userData ? formatNumberToStr(userData.msisdn) : <Skeleton width={150} />}
                <span className={cn.questionMark}>?</span>
            </p>
            <Button onClick={handleDeleteUser} className={cn.button}>
                Да, я хочу удалить профиль
            </Button>
        </div>
    );
};
